import { ResponsiveTheme } from "../.internal/themes/ResponsiveTheme";
export default ResponsiveTheme;